import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import  useStyles  from './styles';

export interface IPickerErrorTextProps{
  isError:boolean;
  isServiceError:boolean;
  serviceUnavailableMessage:string
  notFoundErrorMessage?:string
}
const PickerErrorText:FC<IPickerErrorTextProps> = ({isError,isServiceError, serviceUnavailableMessage, notFoundErrorMessage }) => {
  const classes = useStyles();

  return isError ?
    <Typography variant="body2" className={classes.errorMessage}>
    {isServiceError ? serviceUnavailableMessage : notFoundErrorMessage}
    </Typography> : null
};

export default PickerErrorText;
